import { IConfigurations } from '@epicuro-next/platform/configuration';

export const NAMESPACE_SPOTLIGHT = 'spotlight';

export enum FiltersConfigurationKeys {
  ShowSpotlight = 'spotlight_show',
  HideSpotlightPanel = 'hide-spotlight-panel',
}

export interface FiltersConfigurations
  extends IConfigurations<FiltersConfigurationKeys> {
  [FiltersConfigurationKeys.ShowSpotlight]: boolean;
  [FiltersConfigurationKeys.HideSpotlightPanel]: string[];
}
